import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { dropdownOption } from 'src/app/types/common';
import { NewSUREPARKGroupRequest } from '../../../../../express-tRPC/src/api/tenants/types-generic';

@Component({
  selector: 'app-new-surepark-group-form',
  templateUrl: './new-surepark-group-form.component.html',
  styleUrl: './new-surepark-group-form.component.scss'
})
export class NewSureparkGroupFormComponent {

  @Input() lotIdOptions!: dropdownOption[];
  @Input() timezoneGroupOptions!: dropdownOption[];

  cardFunctionOptions: dropdownOption[] = [
    { name: "Monthly", code: "Monthly" },
    { name: "ValueCard", code: "ValueCard" }
  ];

  antiPassbackOptions: dropdownOption[] = [
    { name: "None", code: "None" },
    { name: "Soft", code: "Soft" },
    { name: "Active", code: "Active" },
    { name: "Time", code: "Time" }
  ];

  antiPassHelpText: string = `<b>None</b> - Disables APB check.</br>
  <b>Soft</b> - If triggered, customer will be allowed to enter/exit, but an event will be created.</br>
  <b>Active</b> - If triggered, customer will not be allowed to enter/exit.</br>
  <b>Time</b> - Active but will only check for violations from the same day.`;

  newSureparkGroupForm = new FormGroup({
    name: new FormControl<string>('', [Validators.required]),
    cardFunction: new FormControl<string>('', [Validators.required]),
    antiPassback: new FormControl<string>('', [Validators.required]),
    stations: new FormControl<string[] | null>([], []),
    schedules: new FormControl<string[] | null>([], []),
  });

  showNewGroupDialog: boolean = false;
  newSureparkGroupFormSubmitted: boolean = false;

  resetForm() {
    this.newSureparkGroupFormSubmitted = false;
    this.newSureparkGroupForm.reset();
  }

  setFormValues(newSureparkGroupData: NewSUREPARKGroupRequest) {
    
    this.newSureparkGroupFormSubmitted = false;

    this.newSureparkGroupForm.setValue({
      name: newSureparkGroupData['name'],
      cardFunction: newSureparkGroupData['cardFunction'],
      antiPassback: newSureparkGroupData['antiPassback'],
      stations: newSureparkGroupData['stations'],
      schedules: newSureparkGroupData['schedules']
    });
    this.newSureparkGroupForm.updateValueAndValidity();

  }

  validateForm() {
    this.newSureparkGroupFormSubmitted = true;
    return this.newSureparkGroupForm.valid;
  }

  getValues() {
    this.newSureparkGroupFormSubmitted = false;
    return this.newSureparkGroupForm.value;
  }
}
